import React, { useState } from "react"
import { CellAssetsHeaderView, CellSearchView } from "../factory/CellViews"

import { 
    WithdrawIcon,
    RechargeIcon,
    TransferIcon,
    FuturesIcon
 } from "../icons";
import { List } from "antd-mobile";
import { DividerOptionView, OptionView } from "../factory/ViewUtil";

 const AssetsHeaderView = ({loginpush, navpush, balance = '0.00', type = '1', changeType, initSelected = true}) => {

    const goSearch = ()=> {
        loginpush('/search/account', false, {type : type})
    }

    const optionData = [
        {
            title : 'Recharge',
            icon : <RechargeIcon/>,
            onClick : () => {
                loginpush('/recharge')
            }
        },
        {
            title : 'Transfer',
            icon : <TransferIcon/>,
            onClick : () => {
                loginpush('/assets/transfer', false, {type : type})
            }
        },
        {
            title : 'Withdraw',
            icon : <WithdrawIcon/>,
            onClick : () => {
                loginpush('/withdraw', false, {type : type})
            }
        },
        {
            title : 'Futures',
            icon : <FuturesIcon/>,
            onClick : () => {
                navpush('/trade')
            }
        }
    ];

    const [selected, setSelected] = useState(initSelected);

    return (
        <>
            <CellSearchView onClick={()=>{goSearch('1')}}>Search</CellSearchView>
            <CellAssetsHeaderView balance={balance}/>
            <List.Item style={{margin : '40px  0'}}><OptionView data={optionData}/></List.Item>
            <List.Item style={{marginBottom : '30px'}}>
                <div style={{width : '66%'}}>
                    <DividerOptionView
                        left={selected} 
                        onChange={(val)=>{
                            setSelected(val);
                            changeType(val)
                        }} 
                        height='40px' 
                        borderRadius='100px' 
                        leftText='Crpyto' 
                        rightText='Amount'/>
                </div>
            </List.Item >
        </>
    )
}

export default React.memo(AssetsHeaderView)